<app-facility-list *ngIf="showList" (toogleView)="show($event)" (getSpaceId)="getSpaceId($event)"></app-facility-list>

<app-facility-onboard *ngIf="!showList" (toogleView)="show($event)" [facilitySpaceId]="editFaciltySpaceId">
</app-facility-onboard>
